import { createAsyncThunk } from '@reduxjs/toolkit';
import { decodeToken, storeToken } from '../../utils/token';
import { signInToFirebase } from '../../utils/firebase';
import { loginApi } from './authAPI';

export const loginAsync = createAsyncThunk('auth/login', async (data, cb) => {
  const res = await loginApi(data);

  storeToken(res.data.sign);

  // Sign in to Firebase with the account-scoped custom token (Firestore real-time).
  // Non-blocking and non-fatal — login proceeds regardless (Firestore reads land in M3).
  signInToFirebase(res.data.firebaseToken);

  const userData = decodeToken(res.data.sign).user;

  return userData;
});
